import type { RefObject } from "react";

/**
 * Ref callback for an uncontrolled secret field: mirrors the node into `ref`
 * and, on detach, overwrites the node's value in place (#141 R2). A retained
 * DOM node (React fiber, devtools, a paused mutation) therefore never keeps
 * the plaintext after the control unmounts before the value was dispatched.
 * Shared by /set-password and the 011-15 credential/recovery controls.
 */
export function secretFieldRef(
  ref: RefObject<HTMLInputElement | null>,
): (node: HTMLInputElement | null) => () => void {
  return (node) => {
    ref.current = node;
    return () => {
      if (node) {
        node.value = "";
      }
      ref.current = null;
    };
  };
}
